// these file contain all constant links and icon and array data and object strings and file link
export const image = 'https://www.tripadapublicschool.in/public/uploads/alumni/1576069050.jpg';
export const images = [
    'https://st2.depositphotos.com/2232796/6946/i/950/depositphotos_69465459-stock-photo-handsome-young-man.jpg',
    'https://smartnet.niua.org/sites/default/files/pictures/picture-35256-1618552861.jpg',
    'https://cdn.pixabay.com/photo/2015/02/13/21/30/handsome-635832_960_720.jpg',
    'https://www.zotezo.com/wp-content/uploads/2020/02/Chris-Evans-pinterest-768x768.jpg',
    'https://i.pinimg.com/originals/7d/a7/ff/7da7ff147a29369788f8283e2a442f7a.jpg',
    'https://c2.staticflickr.com/6/5828/30783444225_72ff0b932f_o.jpg',
    'https://i1.wp.com/www.kyrackramer.com/wp-content/uploads/2014/08/handsome-chinese-man.jpg'
]
export const user = "Vineet";  //username
export const msg = 26;  //messages

// admin data 
export const visitors = 10; // visitors in thousands
export const volume = 100 // browser media volume 
export const files = 2000 // file uploaded to server 
export const mails = 325 //mail from clients

// network data 
export const fileShares = 1000 // file share by user 
export const network = 600 // connected people 
export const returns = 400 // returned customers
export const connections = 100 //connection stability

// achievements
export const ratings = 4000 // rating in a month 
export const achievement = 17


// member performance 

export const members = [
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Skew',
        age: 23,
        post: 'Web developer',
        country: 'England',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2)
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Robert',
        age: 23,
        post: 'Project Manager',
        country: 'Japan',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'jonathan',
        age: 23,
        post: 'sales executive',
        country: 'China',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Saliva',
        age: 23,
        post: 'unit tester',
        country: 'Germen',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Newton',
        age: 23,
        post: 'Human resource',
        country: 'USA',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Fredrick',
        age: 23,
        post: 'digital marketing',
        country: 'Australia',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    },
    {
        id: Math.floor(Math.random() * 9999),
        name: 'Elli',
        age: 25,
        post: 'Graphics designer',
        country: 'Nepal',
        contribution: Math.floor(Math.random() * 99 + 1).toFixed(2),
    }
]
export const order = [
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Skew',
        Address: 'Bayern,Germany',
        date: '22-02-2022',
        status: 'pending',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Fredrick',
        Address: 'Stein,Germany',
        date: '14-08-2022',
        status: 'dispatch',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'jonathan',
        Address: 'Bayern,Germany',
        date: '16-08-2022',
        status: 'pending',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Elli',
        Address: 'Ir-Rabat,Malta',
        date: '25-02-2022',
        status: 'dispatch',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Newton',
        Address: 'L-Imtarfa,Malta',
        date: '29-04-2022',
        status: 'dispatch',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Robert',
        Address: 'Bayern,Germany',
        date: '16-02-2022',
        status: 'completed',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Jonathan',
        Address: 'L-Imdina,Malta',
        date: '19-03-2022',
        status: 'completed',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Saliva',
        Address: 'Bayern,Germany',
        date: '19-07-2022',
        status: 'dispatch',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Saliva',
        Address: 'Rossel-Farm,Germany',
        date: '16-02-2022',
        status: 'pending',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Elli',
        Address: 'Barden-bay,India',
        date: '22-09-2022',
        status: 'pending',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Newton',
        Address: 'Jakarta,Norway',
        date: '09-03-2022',
        status: 'completed',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Jonathan',
        Address: 'Albereno,USA',
        date: '02-04-2022',
        status: 'dispatch',
    }, {
        id: Math.floor(Math.random() * 2349),
        name: 'Fredrick',
        Address: 'De-Fan-top,Philippines',
        date: '12-02-2022',
        status: 'completed',
    },
    {
        id: Math.floor(Math.random() * 2349),
        name: 'Elli',
        Address: 'lornejo,England',
        date: '05-03-2022',
        status: 'pending',
    }, {
        id: Math.floor(Math.random() * 2349),
        name: 'jonathan',
        Address: 'Austria,Germany',
        date: '13-09-2022',
        status: 'dispatch',
    }, {
        id: Math.floor(Math.random() * 2349),
        name: 'Robert',
        Address: 'thimpu,Jakarta',
        date: '12-08-2022',
        status: 'pending',
    }, {
        id: Math.floor(Math.random() * 2349),
        name: 'Fredrick',
        Address: 'München,Germany',
        date: '29-06-2022',
        status: 'completed',
    }

]
export const Products = [
    {
        "shirt": {
            "sold": 245,
            "stock": 234,
            "Date": '2023-01-02',
            "url": [
                "https://purepng.com/public/uploads/large/purepng.com-mens-stylish-shirt-bluebutton-front-shirtgarmentdressshirtfullmensstylishblue-1421526306983zzdmy.png",
                "https://purepng.com/public/uploads/large/purepng.com-slim-fit-mens-full-shirtsbutton-front-shirtgarmentdressshirtfullslim-fit-1421526306937vseuy.png",
                "https://pngimg.com/uploads/dress_shirt/dress_shirt_PNG8117.png",
                "https://purepng.com/public/uploads/large/purepng.com-dress-shirt-detachable-collarbutton-front-shirtgarmentdressshirtfullmensdetachable-1421526307026nyc1s.png",
                "https://purepng.com/public/uploads/large/purepng.com-dress-shirt-detachable-collar-greenbutton-front-shirtgarmentdressshirtfullmensdetachable-1421526307122tzyuu.png"
            ]

        },
        "t-shirt": {
            "sold": 345,
            "stock": 345,
            "Date": "2023-09-05",
            "url": [
                "http://www.pngall.com/wp-content/uploads/2016/04/T-Shirt-PNG-HD.png",
                "http://purepng.com/public/uploads/large/purepng.com-black-t-shirtt-shirtfabrict-shapegramnetsmensblack-1421526429071zidaz.png",
                "http://purepng.com/public/uploads/large/purepng.com-red-mens-polo-shirtpolo-shirtcottongarmentsfebricmensround-kolart-shirt-1421526392953dle6f.png",
                "https://purepng.com/public/uploads/large/purepng.com-sky-blue-mens-polo-shirtpolo-shirtcottongarmentsfebricmenskolarskyblue-1421526391739ohzyf.png",
                "http://pngimg.com/uploads/tshirt/tshirt_PNG5450.png"
            ]
        }
        , "jeans": {
            "sold": 256,
            "stock": 453,
            "Date": "2023-06-08",
            "url": [
                "https://purepng.com/public/uploads/large/purepng.com-mens-jeansgarmentlower-bodydenimjeansblue-1421526362631v0b2x.png", "http://www.pngall.com/wp-content/uploads/5/Ripped-Men-Jeans-PNG.png", "https://purepng.com/public/uploads/large/purepng.com-mens-jeansgarmentlower-bodydenimjeansbluebright-14215263626965rysv.png", "https://purepng.com/public/uploads/medium/purepng.com-mens-jeansgarmentlower-bodydenimjeansmenswash-1421526363461n3wwz.png", "https://purepng.com/public/uploads/large/purepng.com-mens-jeansgarmentlower-bodydenimjeansnavy-blue-1421526362794kpmhb.png"
            ]
        },
        "formal-pant": {
            "sold": 301,
            "stock": 345,
            "Date": "2023-08-12",
            "url": [
                "https://freepngimg.com/thumb/pant/37045-2-mens-pant-file.png", "https://w7.pngwing.com/pngs/141/466/png-transparent-waist-jeans-pants-formal-wear-stx-it20-risk-5rv-nr-eo-jeans-black-abdomen-formal-wear.png",
                "https://image.pngaaa.com/469/1657469-middle.png", "https://w7.pngwing.com/pngs/612/492/png-transparent-trousers-pocket-jeans-formal-wear-men-dress-trousers-black-wedding-dress-up.png", "https://w7.pngwing.com/pngs/518/71/png-transparent-slim-fit-pants-clothing-fashion-jeans-overhead-trouser-leg-thumbnail.png"
            ]
        },
        "formal-shoes": {
            "sold": 321,
            "stock": 323,
            "Date": "2023-12-12",
            "url": [
                "https://toppng.com/uploads/preview/men-shoes-115309690250belwqtlfd.png", "https://image.similarpng.com/very-thumbnail/2021/06/The-man's-brown-shoes-isolated-on-transparent-background-PNG.png", "https://e7.pngegg.com/pngimages/685/946/png-clipart-oxford-shoe-footwear-brogue-shoe-shoemaking-men-shoes-leather-fashion.png", "https://image.similarpng.com/very-thumbnail/2021/06/The-man's-brown-shoes-isolated-on-transparent-background-PNG.png", "https://w7.pngwing.com/pngs/629/503/png-transparent-leather-dress-shoe-brogue-shoe-bullock-carved-tide-shoes-men-s-shoes-brown-retro-mens-thumbnail.png"
            ]

        },
        "sport-shoes": {
            "sold": 342,
            "stock": 362,
            "Date": "2023-12-05",
            "url": [
                "https://e7.pngegg.com/pngimages/723/143/png-clipart-shoe-nike-free-air-force-nike-shoes-image-file-formats-fashion.png", "https://e7.pngegg.com/pngimages/640/509/png-clipart-nike-air-presto-essential-mens-nike-air-presto-essential-mens-sports-shoes-nike-fashion-outdoor-shoe.png", "https://e7.pngegg.com/pngimages/433/833/png-clipart-air-presto-nike-air-max-sneakers-red-nike-white-outdoor-shoe-thumbnail.png", "https://e7.pngegg.com/pngimages/693/953/png-clipart-air-presto-nike-skate-shoe-sneakers-nike-white-outdoor-shoe.png", "https://w7.pngwing.com/pngs/249/485/png-transparent-pair-of-white-and-red-running-shoes-illustration-shoe-running-sneakers-clothing-nike-running-shoes-blue-white-sport.png"
            ]
        },
        "socks": {
            "sold": 450,
            "stock": 500,
            "Date": "2023-04-06",
            "url": [
                "https://e7.pngegg.com/pngimages/956/81/png-clipart-burlington-socks-king-socks-21020-clothing-stance-men-s-wish-you-weren-t-socks-cappelleria-melegari-thumbnail.png","https://www.pngfind.com/pngs/m/14-143267_socks-png-background-image-sock-transparent-png.png","https://e7.pngegg.com/pngimages/190/384/png-clipart-sock-socks-black-socks.png","https://img.lovepik.com/free-png/20211108/lovepik-socks-png-image_400565404_wh1200.png","https://image.similarpng.com/very-thumbnail/2021/06/A-pair-of-socks-isolated-on-transparent-background-PNG.png"
            ]
        }

    }
]